package com.wintermar.inspection.core.ui.component.image.util

enum class FileUploadStatus {
    ERROR_UPLOAD,
    WAITING_TO_UPLOAD,
    UPLOADING,
    NONE,
    COMPLETE
}
